module.exports = __webpack_public_path__ + "static/android-chrome-512x512-63da0f64e263663080546e26a5f0c9a2.png";